let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePoNs")).then(() => parcelRequire('aMgJc'));